import { SEARCH_INPUT_USER_BUYER, SEARCH_OPTION_USER_BUYER } from './constants'

export const filterSearchInput = (search, enterEvent = null) => ({
  type: SEARCH_INPUT_USER_BUYER,
  searchValue: search,
  enterSearchInputFilter: enterEvent,
})
export const filterSearchOptions = (search, selectSearchOption = null) => ({
  type: SEARCH_OPTION_USER_BUYER,
  searchOption: search,
  selectedOptions: selectSearchOption,
})
